import QuizQuestionService from 'src/modules/quizQuestion/quizQuestionService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'QUIZ_QUESTION_FORM';

const quizQuestionFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: quizQuestionFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await QuizQuestionService.find(id);
      }

      dispatch({
        type: quizQuestionFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizQuestionFormActions.INIT_ERROR,
      });

      getHistory().push('/quiz-question');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: quizQuestionFormActions.CREATE_STARTED,
      });

      const record = await QuizQuestionService.create(
        values,
      );

      dispatch({
        type: quizQuestionFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.quizQuestion.create.success'),
      );

      getHistory().push(`/quiz-question/${record.id}`);
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizQuestionFormActions.CREATE_ERROR,
      });
    }
  },

  doCreateBulk: (quizId, values) => async (dispatch) => {
    try {
      dispatch({
        type: quizQuestionFormActions.CREATE_STARTED,
      });

      const record = await QuizQuestionService.createBulk(
        quizId,
        values,
      );

      dispatch({
        type: quizQuestionFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.quizQuestion.create.success'),
      );

      getHistory().push(`/quiz-question/${record.id}`);
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizQuestionFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: quizQuestionFormActions.UPDATE_STARTED,
      });

      await QuizQuestionService.update(id, values);

      dispatch({
        type: quizQuestionFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.quizQuestion.update.success'),
      );

      getHistory().push(`/quiz-question/${id}`);
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizQuestionFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default quizQuestionFormActions;
